import applyUrlParams from './applyUrlParams'

export const createImgixBaseUrl = (source, path) => {
  const pathname = path.charAt(0) !== '/' ? `/${path}` : path
  return `https://${source}.imgix.net${pathname}`
}

export const createImgixUrl = (source, path, options = {}) => {
  const baseUrl = createImgixBaseUrl(source, path)
  return applyUrlParams(baseUrl, options)
}
